import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider, useDispatch, useSelector } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import store, { history } from 'src/store';
import { HistoryRouter as Router } from 'redux-first-history/rr6';
import toast from './utils/toast';

const root = ReactDOM.createRoot(document.getElementById('root'));

if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (e) => {
    const reason = e?.reason;
    const msg =
      (reason && (reason.message || reason.error || reason.statusText)) ||
      (typeof reason === 'string' ? reason : null) ||
      'Something went wrong';
    try {
      toast.error(msg);
    } catch (_) {}
    e.preventDefault();
  });

  window.addEventListener('error', (e) => {
    const err = e?.error;
    const msg = (err && err.message) || e?.message || 'Something went wrong';
    try {
      toast.error(msg);
    } catch (_) {}
  });
}

root.render(
    <Provider store={store}>
      <Router history={history}>
        <React.Suspense>
          <App />
        </React.Suspense>
      </Router>
    </Provider>,
);

reportWebVitals();
